export default {
	init() {
		// JavaScript to be fired on all pages
		console.log('this code is executed con single-exp-place');
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
